import { Link, useLocation } from 'react-router-dom';
import { Button } from '@/components/ui/button';
import { Badge } from '@/components/ui/badge';
import { Calendar, Users, ListTodo, LogOut, Settings, ShoppingCart } from 'lucide-react';

export default function Sidebar({ user, onLogout }) {
  const location = useLocation();

  const isAdmin = user?.role === 'Administrator';
  
  const navItems = [
    { path: '/', label: 'Calendar', icon: Calendar },
    { path: '/purchase-orders', label: 'Open Purchase Orders', icon: ShoppingCart },
    { path: '/employees', label: 'Employees', icon: Users },
    { path: '/queue', label: 'Work Queue', icon: ListTodo },
  ];

  if (isAdmin) {
    navItems.push({ path: '/admin', label: 'Admin', icon: Users });
    navItems.push({ path: '/settings', label: 'Settings', icon: Settings });
  }

  return (
    <aside
      className="w-64 bg-white dark:bg-slate-900 border-r border-border flex flex-col"
      data-testid="sidebar"
    >
      <div className="p-6 border-b border-border">
        <h1 className="text-2xl font-bold tracking-tight text-sky-600">Scheduler</h1>
        <p className="text-xs text-muted-foreground mt-1 uppercase tracking-widest font-semibold">
          Production Control
        </p>
      </div>

      <nav className="flex-1 p-4 space-y-2">
        {navItems.map((item) => {
          const Icon = item.icon;
          const isActive = location.pathname === item.path;
          return (
            <Link key={item.path} to={item.path}>
              <Button
                variant={isActive ? 'default' : 'ghost'}
                className={`w-full justify-start font-medium transition-all ${
                  isActive ? 'bg-sky-600 hover:bg-sky-700 text-white' : 'hover:bg-slate-100'
                }`}
                data-testid={`nav-${item.label.toLowerCase().replace(' ', '-')}`}
              >
                <Icon className="mr-3 h-5 w-5" />
                {item.label}
              </Button>
            </Link>
          );
        })}
      </nav>

      <div className="p-4 border-t border-border space-y-3">
        <div className="px-3 py-2 bg-slate-50 dark:bg-slate-800 rounded-md">
          <p className="text-xs uppercase tracking-widest font-semibold text-muted-foreground">User</p>
          <p className="text-sm font-medium mt-1">{user?.name}</p>
          <p className="text-xs text-muted-foreground truncate">{user?.email}</p>
          <Badge 
            variant="secondary" 
            className="mt-2 text-[10px]"
            data-testid="user-role-badge"
          >
            {user?.role}
          </Badge>
        </div>
        <Button
          variant="outline"
          className="w-full justify-start"
          onClick={onLogout}
          data-testid="logout-button"
        >
          <LogOut className="mr-3 h-4 w-4" />
          Logout
        </Button>
      </div>
    </aside>
  );
}
